import { action, computed, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../commonv3/api/RemoteResourceV3';
import { CoachSkillCertificationIndexView, CoachSkillType } from '../types/coachSkillCertifications';
import { CoachSkillCertificationApis } from '../apis/coachSkillCertifications';
import autobind from 'autobind-decorator';

export class CoachSkillCertificationState {
  initialized = false;
  certificates: RemoteResourceV3<CoachSkillCertificationIndexView[]> = RemoteResourceV3.empty();

  constructor() {
    makeObservable(this, {
      initialized: observable,
      certificates: observable,
      init: action.bound,
      initIfNecessary: action.bound,
      hasAnySkill: computed,
    });
  }

  async init() {
    this.initialized = false;
    try {
      await updateRemoteResourceV3(
        this.certificates,
        (v) => (this.certificates = v),
        () => CoachSkillCertificationApis.findAll()
      );
    } finally {
      this.initialized = true;
    }
  }

  async initIfNecessary() {
    if (this.certificates.isEmpty()) {
      await this.init();
    }
  }

  @autobind
  hasSkill(type: CoachSkillType): boolean {
    return !!this.certificates.getOrElse([]).find((c) => c.type == type);
  }

  @autobind
  hasAnySkills(types: CoachSkillType[]): boolean {
    return !!this.certificates.getOrElse([]).find((c) => types.includes(c.type));
  }

  get hasAnySkill(): boolean {
    return this.certificates.getOrElse([]).length > 0;
  }
}
